/**
 * useSalesAllocationsSummary — 관급 잔량(배정−출하) 총합 요약 (홈 KPI 관급 잔량용).
 *
 * salesRepo.fetchAllocations() 를 1회 호출해 Σ.totalRemain·Σ.totalAllocated·Σ.totalShipped 를 도출.
 * 관급 거래처 ~14곳뿐. 스냅샷 데이터라 delta 비교 없음.
 */
import { useEffect, useState } from "react";
import { salesRepo } from "@/services/sales.repository";

export interface SalesAllocationsSummary {
  /** 총 잔량 (㎥) */
  totalRemain: number;
  /** 총 배정량 (㎥) */
  totalAllocated: number;
  /** 총 출하량 (㎥) */
  totalShipped: number;
  /** 거래처 수 */
  count: number;
  /** 스냅샷 기준일 (가장 최신) */
  asOf: string;
  loaded: boolean;
  error: string | null;
}

export function useSalesAllocationsSummary(enabled = true): SalesAllocationsSummary {
  const [state, setState] = useState<SalesAllocationsSummary>({
    totalRemain: 0,
    totalAllocated: 0,
    totalShipped: 0,
    count: 0,
    asOf: "",
    loaded: false,
    error: null,
  });

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    salesRepo
      .fetchAllocations()
      .then((rows) => {
        if (cancelled) return;
        let totalRemain = 0;
        let totalAllocated = 0;
        let totalShipped = 0;
        let asOf = "";
        for (const r of rows) {
          totalRemain += r.totalRemain;
          totalAllocated += r.totalAllocated;
          totalShipped += r.totalShipped;
          if (r.asOf && r.asOf > asOf) asOf = r.asOf;
        }
        setState({
          totalRemain: Math.round(totalRemain),
          totalAllocated: Math.round(totalAllocated),
          totalShipped: Math.round(totalShipped),
          count: rows.length,
          asOf,
          loaded: true,
          error: null,
        });
      })
      .catch((e) => {
        if (cancelled) return;
        setState((s) => ({ ...s, loaded: true, error: e instanceof Error ? e.message : String(e) }));
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return state;
}
